<div class="modal-wrapper">
    <div class="modal-header">
        <h4 class="modal-title">
            <i class="fas fa-exclamation-circle text-red"></i> Oops - A Problem Occurred!
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div><p>There was a problem. Please try again.</p> <p>If the problem persists, please contact the IT Service Desk at <a href="mailto:itservicedesk@kenan-flagler.unc.edu">itservicedesk&#64;kenan-flagler.unc.edu</a></p></div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="activeModal.dismiss('Button click')">Got it!</button>
    </div>
</div>
